import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { RadioFieldGroup } from '@/components/functional/Form/RadioField';
import { RFP_OFFER_MEMBER_MEMBER_TYPES, RFP_OFFER_MEMBER_MEMBER_TYPE_COMPANY_VALUE, } from '@/utils/constants/rfp/rfpOfferMember/memberType';
import { isRequired } from '@/utils/validate/conditions';
/**
 * 案件メンバー追加 メンバー種類
 */
export const RfpProMemberAddMemberTypeField = (props) => {
    const { className = '', initialValue = RFP_OFFER_MEMBER_MEMBER_TYPE_COMPANY_VALUE, name, } = props;
    return (_jsx(RadioFieldGroup, { className: clsx('!gap-y-8', className), initialValue: initialValue, isNumberValue: true, items: RFP_OFFER_MEMBER_MEMBER_TYPES, name: name, row: true, space: 'wide', validate: isRequired }));
};
